import axios from "axios";
import React, { useEffect, useState } from "react";
import { scripts } from "@findonflow/find-flow-contracts-1.0";
import { Script } from "../../../functions/script";
import { useStateChanged } from "../../../functions/DisabledState";
import ProfileThoughtsDataBox from "./ProfileThoughtsDataBox";
import { useLocation, useNavigate, useParams } from "react-router";
import LiveFeedThoughtBox from "../../livefeed/LiveFeedThoughtBox";
import { Card } from "react-bootstrap";
import "./ProfileThoughts.scss";
import { Link } from "react-router-dom";
import { useUserProfile } from "../../../functions/useUserProfile";
import { getOwnedThoughts } from "../../../functions/flow-interactions/scripts";

const ProfileThoughts = (props) => {
  const { profile, type } = props;
  const [grafflePageSize, setGrafflePageSize] = useState(50);
  const [thoughtsIds, setThoughtsIds] = useState([]);
  const [thoughtsAddrs, setThoughtsAddrs] = useState([]);
  const [thoughtsData, setThoughtsData] = useState(null);
  const [postedClicked, setPostedClicked] = useState(false);
  const [ownProfile, setOwnProfile] = useState(false);

  const { thoughtId, name } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useUserProfile();
  // console.log(thoughtId);
  // const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
  // const graffleUrl =
  //   process.env.REACT_APP_GRAFFLE_SEARCH_URL +
  //   "search?" +
  //   `eventType=A.${contractAddress}.FindThoughts.Published&creator=${profile.profile.address}`;

  //function to get owned thoughts and sort by created value

  const profileAddress = profile?.profile?.address || ""

  useEffect(() => {
    if (user) {
      if (
        type === "owner" ||
        name === user.profile.findName ||
        name === user.profile.address
      ) {
        setOwnProfile(true);
      } else{
        setOwnProfile(false)
      }
    } else{
      setOwnProfile(false)
    }
  }, [type, name, user]);

  //on page load - get all owned thoughts or set Id for single if id is given via url
  useEffect(() => {
    setThoughtsData(null);
    setThoughtsAddrs([]);
    setThoughtsIds([]);
    if (!thoughtId) {
      getOwnedThoughts(profileAddress).then(setThoughtsData)
    } else {
      setThoughtsIds([Number(thoughtId)]);
      setThoughtsAddrs([profileAddress]);
    }
  }, [thoughtId, location]);

  //if single Id run getfindthought for just that thought
  useEffect(() => {
    if (thoughtId) {
      setThoughtsData(null);
      async function getFindThoughts(addresses, ids) {
        const getThoughts = await Script(scripts.getFindThoughts, {
          addresses: addresses,
          ids: ids,
        });
        setThoughtsData(getThoughts);
      }
      try {
        getFindThoughts(thoughtsAddrs, thoughtsIds);
      } catch (error) {
        console.log(error);
      }
    }
  }, [thoughtsIds, location]);

  //on successful tx - if the post button was clicked get the new thoughts (stops rerender on reaction which is done in thought item)
  useEffect(() => {
    if (postedClicked) {
      console.log("debug",{profile})
      getOwnedThoughts(profileAddress).then(setThoughtsData)
      setPostedClicked(false);
    }
  }, [useStateChanged()]);

  return (
    <div id="profile-thoughts-wrapper">
      {ownProfile && !thoughtId && (
        <Card className="mb-3">
          <LiveFeedThoughtBox
            user={profile}
            setPostedClicked={setPostedClicked}
          />
        </Card>
      )}
      {thoughtId && (
        <div id="back-all-thoughts-row">
          <Link to={`/${name}/thoughts`}>
            <i className="fa fa-arrow-left " aria-hidden="true" />
            &nbsp;&nbsp;
            <span id="">Back to all thoughts</span>{" "}
          </Link>
        </div>
      )}
      <ProfileThoughtsDataBox profile={profile} thoughtsData={thoughtsData} />
    </div>
  );
};

export default ProfileThoughts;
